import { CaptionLinkTypography } from '../../../../atoms';
import { Button } from '../../button';

type NoDataButtonProps = React.PropsWithChildren<{
	onAction: () => void;
}>;

export const NoDataButton: React.FC<NoDataButtonProps> = ({ children, onAction }) => {
	return (
		<Button variant="hyperlink" size="xs" className="text-primary" onClick={onAction} data-testid="no-data-button">
			<CaptionLinkTypography className="text-[1rem] text-primary">{children}</CaptionLinkTypography>
		</Button>
	);
};
